export default{
    methods:{
        async getTicketCount(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dashboard/ticket_status_counts', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getticketCountByTemp(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dashboard/ticket_counts_by_template', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getticketTagsByTemp(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dashboard/get_all_tags_by_template', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getAllProducts(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/filters/get_all_templates', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getAllTickets(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_all_tickets', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async ticketByProducts(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dashboard/ticket_by_products', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async ticketByTemplates(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dashboard/ticket_by_templates', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async ticketCreationType(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dashboard/ticket_creation_type', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async highPriorityTickets(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dashboard/high_priority_tickets', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async dashTicketPriority(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dashboard/ticket_priority', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async ticketByDepartment(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dashboard/ticket_by_departments', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getDepartments(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post("/department/list_view",params)
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getUserListFilter(params){
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/filters/get_users', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getAllTags(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_all_tags', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
    }
}